import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import numberWithSpaces from 'src/shared/functions/numberWithSpaces';

type LargeCounterProps = {
  count: number;
  displaySuffix?: boolean;
};

export const LargeCounter = (props: LargeCounterProps) => {
  const { count, displaySuffix = false } = props;
  const { t } = useTranslation(['dashboard']);
  const theme = useTheme();
  const isXS = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Typography variant={isXS ? 'h5' : 'h4'} sx={{ fontWeight: 600 }}>
      {numberWithSpaces(count)}
      <Box component='span' sx={{ fontWeight: 400, fontSize: '0.7em', color: (thm) => thm.palette.text.secondary }}>
        {displaySuffix && ` ${t('dashboard:piciesShort')}`}
      </Box>
    </Typography>
  );
};
